import Configs from "../config";
import { IArchive, IUserIRoute } from "../generated/Api";

export interface IUserWithBilling extends IUserIRoute {
  billing: { zeroCost?: boolean };
}

const getDetail = async (userUid: string): Promise<IArchive | null> => {
  try {
    const response: Response = await fetch(
      `${Configs.SERVER_URL}/archive/${userUid}`
    );
    if (response.status === 200) {
      const responseObject = await response.json();
      return responseObject.data;
    }
    return null;
  } catch (err) {
    return null;
  }
};

const update = async (body: {
  userUid: string;
  archive: Partial<IArchive>;
}): Promise<IArchive> => {
  try {
    const response = await fetch(`${Configs.SERVER_URL}/archive`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      const responseObject = await response.json();
      return responseObject.data;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const ArchiveAPI = {
  getDetail,
  update,
};
